import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripePayoutService {
  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPEPAYOUT_LIST(
          $filter: StripePayoutFilterInput
          $orderBy: StripePayoutOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          stripePayoutList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              arrivalDate
              method
              amount
              currency
              status
              type
              automatic
              externalAccount {
                id
                bankName
                last4
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });
    return response.data.stripePayoutList;
  }
}
